module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point05_06_sunset-381e55377b30ecdd27beb8ffdf09e1bf.jpg";